module.exports = __webpack_public_path__ + "img/B2B2C_customer3.f778c5f9.png";